import React, { useEffect, useState } from "react";
import { Box, Card, CardContent } from "@mui/material";
import { Button, DateField,FunctionField, SimpleShowLayout, TopToolbar, useGetOne, useNotify, useRedirect } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import { Link, useParams } from "react-router-dom";
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { TrashButton } from "../components";
import { DownloadFile, getNameAndCompanyNamewithAddress, getResource } from "../common";

const ConstructHistoryShow = () => {
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
    const [files,setFiles] = useState(null);
  const { id } = useParams(); 
  const redirect = useRedirect();
   const notify = useNotify();

  const { data, isLoading } = useGetOne("constructHistory", { id });
  useEffect(() => {
    if(!isLoading && data){
      setRecord(data);
    }
  },[data,isLoading]);

  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, margin: 0 }}>
        <TopToolbar>
            <Button
                label="請求書を作成"
                onClick={() => redirect(`/invoice-form/constructHistory/${id}`)}
                startIcon={<NoteAddIcon />}
            />
            <Button
                label="修理情報編集"
                onClick={() => redirect(`/constructHistory/${id}`)}
                startIcon={<EditIcon />}
            />
        </TopToolbar>
    </Box>
  );

  const labelStyle = (text) => (
    <div style={{ backgroundColor: "#eee", color: "#666", paddingLeft: "5px" }}>
      {text}
    </div>
  );

  const handleDelete = (filePath) => {
    const deleteFile = async (filePath) => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/pictures`,{
          method: "DELETE",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
          body: JSON.stringify({filePath}),
        });
        const data = await response.json();
        if (data.isError) {
          notify(data.message || "エラーが発生しました",{type:"error"});
        }
        else{
          notify("削除されました",{type:"sccuess"});
          window.location.reload();
        }
      } catch (error) {
        notify("エラーが発生しました",{type:"error"});
      }
    };
    deleteFile(filePath);
  };

    useEffect(()=>{
      if(record){
        console.log(record)
        const fetchFiles = async () => {
          try {
            const response = await fetch(`${process.env.REACT_APP_API_DIR}/pictures/construct/${record.id}`,{
              method: "GET",
              headers: new Headers({ "Content-Type": "application/json" }),
              mode: "cors",
              credentials: "include",
            });
            const data = await response.json();
            console.log(data);
            if (data.files) {
              setFiles(data.files);
            }
          } catch (error) {
            console.error("ファイル一覧の取得に失敗しました:", error);
            notify("ファイル一覧の取得に失敗しました",{type:"error"});
          }
        };
        fetchFiles();
      }
    },[record]);

  return (
    <>
      <CustomTopToolbar/>
      <Card>
        <CardContent>
            <SimpleShowLayout record={record}>
                {/* <FunctionField source="number" label={labelStyle("修理No")} style={{ paddingLeft: "5px" }} render={(record) => {
                  return String(record.number).padStart(5, "0");
                }}/> */}
                <DateField source="constructDate" label={labelStyle("修理日")} style={{ paddingLeft: "5px" }} />
                <FunctionField source="staffName" label={labelStyle("担当者名")} style={{ paddingLeft: "5px" }} render={record => {return record.staffName}} />
                <FunctionField source="content" label={labelStyle("修理内容")} style={{ paddingLeft: "5px" }} render={record => {return record.content}} />
                <FunctionField
                  source="pictureURL"
                  label={labelStyle("工事写真")}
                  render={(record) => (
                    <div style={{ paddingLeft: "5px",margin:"0" }}>
                      {files && files.length > 0 ? (
                        <>
                          {files.map((file, index) => (
                            <div key={index}>
                              <Link onClick={() => DownloadFile(file.url)} >{file.name}</Link>
                              <TrashButton onDelete={() => handleDelete(file.url)} />
                            </div>
                          ))}
                        </>
                      ) : null}
                    </div>
                  )}
                />
                <FunctionField
                  source="customerId"
                  label={labelStyle("顧客名")} 
                  style={{ paddingLeft: "5px" }}
                  render={(record) => {
                    return <Link to={`/customers-construct/show/${record.customerId}`}>{getNameAndCompanyNamewithAddress(record)}</Link>;
                  }}
                />
                <FunctionField
                  source="invoiceId"
                  label={labelStyle("請求情報")} 
                  style={{ paddingLeft: "5px" }}
                  render={(record) => {
                    // return <Link to={`/invoiceHistory/show/${record.invoiceId}`}>{record.invoiceNumber && String(record.invoiceNumber).padStart(5, "0")}</Link>;
                    return <Link to={`/invoiceHistory/show/${record.invoiceId}`}>{record.invoiceNumber && <>請求詳細はこちら</>}</Link>;
                  }}
                />
                <DateField source="createDate" label={labelStyle("登録日")} style={{ paddingLeft: "5px" }} />
                <DateField source="updateDate" label={labelStyle("更新日")} style={{ paddingLeft: "5px" }} />
                
            </SimpleShowLayout>
        </CardContent>
      </Card>
    </>

  );
};

export default ConstructHistoryShow;

